/* eslint-disable */
// /src/pages/StoreOrdersPage.jsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { useDriverStatusContext } from "../context/DriverStatusContext";
import {
    listStoreOrdersByOwnerPhoneE164,
    updateStoreOrderStatus,
} from "../services/storeOrderService";
import { fetchProductById } from "../services/storePublicService";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #f7faff;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;

const TopBar = styled.div`
  height: 52px;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid #e6eefc;
  button {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #111;
    padding: 6px 8px;
    border-radius: 10px;
    font-weight: 700;
    &:active {
      transform: translateY(1px);
    }
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 16px 20px;
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
`;

const InfoText = styled.div`
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
`;

/* 주문 카드 리스트 */
const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Card = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 12px 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

const TitleWrap = styled.div`
  min-width: 0;
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 3px;
  line-height: 1.4;
`;

const Meta = styled.div`
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.5;
  white-space: pre-line;
`;

const Price = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.4;
`;

const CardMiddle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  ${({ status }) => {
        switch (status) {
            case "pending_deposit":
                return `
          background: #FEF3C7;
          color: #92400E;
          border: 1px solid #FACC15;
        `;
            case "paid":
                return `
          background: #DBEAFE;
          color: #1D4ED8;
          border: 1px solid #60A5FA;
        `;
            case "in_progress":
                return `
          background: #ECFEFF;
          color: #0E7490;
          border: 1px solid #67E8F9;
        `;
            case "shipped":
                return `
          background: #DCFCE7;
          color: #166534;
          border: 1px solid #4ADE80;
        `;
            case "completed":
                return `
          background: #E0E7FF;
          color: #3730A3;
          border: 1px solid #A5B4FC;
        `;
            case "cancelled":
                return `
          background: #FEE2E2;
          color: #B91C1C;
          border: 1px solid #FCA5A5;
        `;
            default:
                return `
          background: #E5E7EB;
          color: #4B5563;
          border: 1px solid #D1D5DB;
        `;
        }
    }}
`;

const ExpandButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 12px;
  color: #2563eb;
  cursor: pointer;
  padding: 4px 0;
`;

const CardBottom = styled.div`
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.6;
`;

const LabelRow = styled.div`
  display: flex;
  gap: 6px;
`;

const LabelKey = styled.div`
  width: 70px;
  flex-shrink: 0;
  color: #9ca3af;
`;

const LabelValue = styled.div`
  flex: 1;
  white-space: pre-line;
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
`;

const SmallButton = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  color: #4b5563;
`;

const PrimarySmallButton = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 0;
  background: #2563eb;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
`;

const EmptyBox = styled.div`
  margin-top: 40px;
  padding: 24px 14px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #ffffff;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.7;
`;

/* 계좌 섹션 */
const SectionLabel = styled.h3`
  margin: 10px 0 2px;
  font-size: 14px;
  color: #0f172a;
  font-weight: 800;
`;

const SectionDivider = styled.hr`
  height: 1px;
  border: 0;
  background: #e5eaf5;
  margin: 0 0 8px;
`;

const BankBox = styled.div`
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  .row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }
  .copy {
    border: 1px solid #d1d5db;
    background: #fff;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }
`;

const KRW = (n = 0) => Number(n || 0).toLocaleString("ko-KR") + "원";
const PTS = (n = 0) => Number(n || 0).toLocaleString("ko-KR") + "P";

const nOrNull = (v) => {
    if (v === null || v === undefined) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};

const readPointsUsed = (o) => {
    const cand = [
        o?.points?.used, // ✅ 서비스 기본
        o?.payment?.pointsUsed, // ✅ 서비스 기본
        o?.price?.pointsUsed, // 혹시 누군가 저장했을 때
        o?.pointsUsed, // 레거시
    ];
    for (const v of cand) {
        const n = nOrNull(v);
        if (n !== null) return Math.max(0, Math.trunc(n));
    }
    return 0;
};

const readTotal = (o) => {
    // ✅ 서비스 기본: price.total
    const cand = [o?.price?.total, o?.totalPrice, o?.price?.payableTotal];
    for (const v of cand) {
        const n = nOrNull(v);
        if (n !== null) return Math.max(0, Math.trunc(n));
    }
    return 0;
};

const readPayable = (o) => {
    // ✅ 서비스 기본: price.payableTotal
    const cand = [o?.price?.payableTotal, o?.payableTotal, o?.price?.total, o?.totalPrice];
    for (const v of cand) {
        const n = nOrNull(v);
        if (n !== null) return Math.max(0, Math.trunc(n));
    }
    return 0;
};

const formatDate = (ts) => {
    if (!ts) return "-";
    try {
        const d = ts.toDate ? ts.toDate() : new Date(ts);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}.${m}.${day}`;
    } catch {
        return "-";
    }
};

const formatShipDate = (v) => {
    if (!v) return "-";
    try {
        const d = v.toDate ? v.toDate() : new Date(v);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}.${m}.${day}`;
    } catch {
        return "-";
    }
};

const statusLabel = (s) => {
    switch (s) {
        case "pending_deposit":
            return "입금 대기";
        case "paid":
            return "입금 확인 요청";
        case "in_progress":
            return "물품 확인중";
        case "shipped":
            return "발송 완료";
        case "completed":
            return "완료";
        case "cancelled":
            return "취소";
        default:
            return "알 수 없음";
    }
};

export default function StoreOrdersPage() {
    const nav = useNavigate();
    const { phoneE164, loading: driverLoading } = useDriverStatusContext();

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submittingId, setSubmittingId] = useState(null);
    const [expandedId, setExpandedId] = useState(null);

    // ✅ productId -> bankAccount 캐시
    const [bankByProductId, setBankByProductId] = useState({});

    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!phoneE164) {
                setLoading(false);
                setOrders([]);
                return;
            }

            setLoading(true);
            try {
                const list = await listStoreOrdersByOwnerPhoneE164(phoneE164, { limitCount: 100 });
                if (cancelled) return;
                setOrders(list);
            } catch (e) {
                console.error("[StoreOrdersPage] list error", e);
                if (!cancelled) setOrders([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        if (!driverLoading) run();

        return () => {
            cancelled = true;
        };
    }, [phoneE164, driverLoading]);

    // ✅ 주문 리스트가 바뀌면: 필요한 productId들만 골라서 bankAccount 추가 로드
    useEffect(() => {
        let cancelled = false;

        const collectProductIds = (list) => {
            const ids = [];
            (list || []).forEach((o) => {
                const items = Array.isArray(o.items) ? o.items : [];
                if (items.length) {
                    items.forEach((it) => {
                        if (it && it.productId) ids.push(String(it.productId));
                    });
                } else if (o && o.productId) {
                    ids.push(String(o.productId));
                }
            });
            return Array.from(new Set(ids)).filter(Boolean);
        };

        (async () => {
            try {
                const productIds = collectProductIds(orders);
                if (!productIds.length) return;

                const missing = productIds.filter((pid) => !(pid in (bankByProductId || {})));
                if (!missing.length) return;

                const nextMap = {};

                await Promise.all(
                    missing.map(async (pid) => {
                        try {
                            const p = await fetchProductById(pid);
                            const bank = typeof p?.bankAccount === "string" ? p.bankAccount.trim() : "";
                            nextMap[pid] = bank;
                        } catch (e) {
                            console.error("[StoreOrdersPage] fetchProductById error", pid, e);
                            nextMap[pid] = "";
                        }
                    })
                );

                if (cancelled) return;

                setBankByProductId((prev) => ({
                    ...(prev || {}),
                    ...nextMap,
                }));
            } catch (e) {
                console.error("[StoreOrdersPage] bank map build error", e);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [orders, bankByProductId]);

    const handleToggleExpand = (id) => {
        setExpandedId((prev) => (prev === id ? null : id));
    };

    const handleMarkPaid = async (order) => {
        if (!order?.id) return;
        const ok = window.confirm(
            "정말 무통장 입금을 완료하셨나요?\n\n입금 후 잘못 누르셨다면, 고객센터로 연락해 주세요."
        );
        if (!ok) return;

        try {
            setSubmittingId(order.id);
            await updateStoreOrderStatus(order.id, "paid");
            setOrders((prev) => prev.map((o) => (o.id === order.id ? { ...o, status: "paid" } : o)));
            alert("입금 확인 요청이 등록되었습니다.");
        } catch (e) {
            console.error("[StoreOrdersPage] mark paid error", e);
            alert("상태 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            setSubmittingId(null);
        }
    };

    const renderOrderCard = (o) => {


        console.log("[StoreOrdersPage][order raw]", {
            id: o?.id,
            totalPrice: o?.totalPrice,
            price: o?.price,
            points: o?.points,
            payment: o?.payment,
            // 혹시 pricing으로 저장돼있는 케이스도 체크
            pricing: o?.pricing,
        });

        const created = formatDate(o.createdAt);

        const items = Array.isArray(o.items) ? o.items : [];
        const totalQty = items.length
            ? items.reduce((sum, it) => sum + Number(it.qty || 0), 0)
            : o.qty || 1;

        const pointsUsed = readPointsUsed(o);
        const total = readTotal(o);
        const payable = readPayable(o) || Math.max(0, total - pointsUsed);


        console.log("[StoreOrdersPage][computed]", {
            id: o?.id,
            pointsUsed,
            total,
            payable,
        });

        const pointsLine = pointsUsed > 0 ? `포인트 사용 -${PTS(pointsUsed)}` : `포인트 사용 안함`;

        const itemsOptionText = (() => {
            if (!items.length) {
                const topOpts = Array.isArray(o.optionSelections) ? o.optionSelections : [];
                if (!topOpts.length) return "선택된 옵션 없음";
                return topOpts
                    .map((op) =>
                        op.extraPrice ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})` : `${op.groupName}: ${op.value}`
                    )
                    .join(", ");
            }

            if (items.length === 1) {
                const it = items[0];
                const opts = Array.isArray(it.optionSelections) ? it.optionSelections : [];
                if (!opts.length) return "선택된 옵션 없음";
                return opts
                    .map((op) =>
                        op.extraPrice ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})` : `${op.groupName}: ${op.value}`
                    )
                    .join(", ");
            }

            return items
                .map((it) => {
                    const title = it.productTitle || it.productTitleSnapshot || "";
                    const qty = Number(it.qty || 0);
                    const opts = Array.isArray(it.optionSelections) ? it.optionSelections : [];
                    if (!opts.length) return `${title} · 수량 ${qty}개 — 옵션 없음`;
                    const optText = opts
                        .map((op) =>
                            op.extraPrice ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})` : `${op.groupName}: ${op.value}`
                        )
                        .join(", ");
                    return `${title} · 수량 ${qty}개 — ${optText}`;
                })
                .join("\n");
        })();

        const ordererLine = o.orderer ? `${o.orderer.name || ""} / ${o.orderer.phone || ""}` : "-";

        const receiverAddr = o.receiver ? `${o.receiver.addr1 || ""} ${o.receiver.addr2 || ""}`.trim() : "";

        const canMarkPaid = o.status === "pending_deposit";

        const showShippingInfo =
            (o.status === "shipped" || o.status === "completed") &&
            (o.shippingCarrier || o.shippingTrackingNo || o.shippingShipDate);

        const bankText = (() => {
            if (items.length) {
                const lines = items
                    .map((it) => {
                        const pid = it?.productId ? String(it.productId) : "";
                        if (!pid) return "";
                        const bank = bankByProductId?.[pid] || "";
                        if (!bank) return "";
                        return `${bank}`;
                    })
                    .filter(Boolean);

                return Array.from(new Set(lines)).join("\n");
            }

            const pid = o?.productId ? String(o.productId) : "";
            if (!pid) return "";
            return bankByProductId?.[pid] || "";
        })();

        const canShowBank = !!bankText;

        const titleText =
            o.productTitleSnapshot ||
            (items.length === 1 ? items[0]?.productTitleSnapshot || items[0]?.productTitle : "") ||
            "상품명 없음";

        const metaText = [`주문일 ${created} · 수량 ${totalQty}개`, pointsUsed > 0 ? pointsLine : ""]
            .filter(Boolean)
            .join("\n");

        return (
            <Card key={o.id}>
                <CardTop>
                    <TitleWrap>
                        <Title>{titleText}</Title>
                        <Meta>{metaText}</Meta>
                    </TitleWrap>
                    {/* ✅ 최종 결제(입금) 금액을 우선 표시 */}
                    <Price>{KRW(payable)}</Price>
                </CardTop>

                <CardMiddle>
                    <StatusBadge status={o.status}>{statusLabel(o.status)}</StatusBadge>
                    <ExpandButton onClick={() => handleToggleExpand(o.id)}>
                        {expandedId === o.id ? "접기" : "상세 보기"}
                    </ExpandButton>
                </CardMiddle>

                {expandedId === o.id && (
                    <>
                        <CardBottom>
                            <LabelRow>
                                <LabelKey>포인트</LabelKey>
                                <LabelValue>{pointsUsed > 0 ? `-${PTS(pointsUsed)}` : "사용 안함"}</LabelValue>
                            </LabelRow>
                            <LabelRow>
                                <LabelKey>결제금액</LabelKey>
                                <LabelValue>{KRW(payable)}</LabelValue>
                            </LabelRow>

                            <div style={{ marginTop: 8, paddingTop: 6, borderTop: "1px dashed #E5E7EB" }} />

                            <LabelRow>
                                <LabelKey>옵션</LabelKey>
                                <LabelValue>{itemsOptionText}</LabelValue>
                            </LabelRow>
                            <LabelRow>
                                <LabelKey>주문자</LabelKey>
                                <LabelValue>{ordererLine}</LabelValue>
                            </LabelRow>
                            <LabelRow>
                                <LabelKey>배송지</LabelKey>
                                <LabelValue>
                                    {o.receiver?.name
                                        ? `${o.receiver.name} / ${o.receiver.phone || ""}\n${receiverAddr}`
                                        : "-"}
                                </LabelValue>
                            </LabelRow>
                            {o.receiver?.memo ? (
                                <LabelRow>
                                    <LabelKey>요청사항</LabelKey>
                                    <LabelValue>{o.receiver.memo}</LabelValue>
                                </LabelRow>
                            ) : null}

                            {showShippingInfo && (
                                <>
                                    <div style={{ marginTop: 8, paddingTop: 6, borderTop: "1px dashed #E5E7EB" }} />
                                    <LabelRow>
                                        <LabelKey>택배사</LabelKey>
                                        <LabelValue>{o.shippingCarrier || "-"}</LabelValue>
                                    </LabelRow>
                                    <LabelRow>
                                        <LabelKey>운송장</LabelKey>
                                        <LabelValue>{o.shippingTrackingNo || "-"}</LabelValue>
                                    </LabelRow>
                                    <LabelRow>
                                        <LabelKey>발송일</LabelKey>
                                        <LabelValue>{o.shippingShipDate ? formatShipDate(o.shippingShipDate) : "-"}</LabelValue>
                                    </LabelRow>
                                </>
                            )}

                            {canShowBank ? (
                                <div style={{ marginTop: 6 }}>
                                    <SectionLabel>입금 계좌</SectionLabel>
                                    <SectionDivider />
                                    <BankBox>
                                        <div className="row">
                                            <div style={{ fontWeight: 400, color: "#0f172a", whiteSpace: "pre-line" }}>
                                                {bankText}
                                            </div>
                                            <button
                                                className="copy"
                                                type="button"
                                                onClick={() => {
                                                    navigator.clipboard?.writeText(bankText).then(() => alert("계좌번호를 복사했어요."));
                                                }}
                                            >
                                                계좌 복사
                                            </button>
                                        </div>
                                    </BankBox>
                                </div>
                            ) : null}
                        </CardBottom>

                        <ActionRow>
                            <SmallButton type="button" onClick={() => handleToggleExpand(o.id)}>
                                닫기
                            </SmallButton>

                            {canMarkPaid && (
                                <PrimarySmallButton
                                    type="button"
                                    onClick={() => handleMarkPaid(o)}
                                    disabled={submittingId === o.id}
                                >
                                    {submittingId === o.id ? "처리 중..." : "입금 완료했어요"}
                                </PrimarySmallButton>
                            )}
                        </ActionRow>
                    </>
                )}
            </Card>
        );
    };

    return (
        <Wrap>
            <Sheet>
                <TopBar>
                    <button onClick={() => nav("/store")} aria-label="스토어로 이동">
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#111"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M3 11.5L12 4l9 7.5" />
                            <path d="M5 10.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a 1 1 0 0 0 1-1v-9.5" />
                        </svg>
                        스토어로 이동
                    </button>
                </TopBar>

                <Body>
                    <BrandHeader subtitle="주문 내역" />
                    <InfoText>미터점 스토어에서 주문한 내역을 확인할 수 있습니다.</InfoText>

                    {driverLoading ? (
                        <div>불러오는 중…</div>
                    ) : !phoneE164 ? (
                        <EmptyBox>
                            로그인 정보를 찾을 수 없습니다.
                            <br />
                            홈 화면에서 다시 접속해 주세요.
                        </EmptyBox>
                    ) : loading ? (
                        <div>불러오는 중…</div>
                    ) : orders.length === 0 ? (
                        <EmptyBox>주문 내역이 없습니다.</EmptyBox>
                    ) : (
                        <List>{orders.map(renderOrderCard)}</List>
                    )}
                </Body>
            </Sheet>
        </Wrap>
    );
}
